import * as DKFDS from 'dkfds';
import $ from 'jquery';
import { fdsReset, fdsShowError } from '../modals';

let contacts = null;
let source = '';

function isAddingApplicant() {
    return source && source === "applicant";
}

function addContacts($modal) {
    let contactIndexes;
    const selectedContacts = [];

    if (isAddingApplicant()) {
        //We are adding an applicant, us radios
        contactIndexes = $('input:radio:checked[name=contactResult]').map(function () {
            return this.value;
        }).get();
    } else {
        contactIndexes = $('input:checkbox:checked[name=contactResult]').map(function () {
            return this.value;
        }).get();
    }
    if (contactIndexes.length > 0) {
        $.each(contactIndexes, function (index, contactIndex) {
            selectedContacts.push(contacts[contactIndex]);
        });
        if (isAddingApplicant()) {
            $('#useApplicant').val(JSON.stringify(selectedContacts)).closest('form').submit();
        } else {
            $('#addedContacts').val(JSON.stringify(selectedContacts)).closest('form').submit();
        }
        new DKFDS.Modal($modal.get(0)).hide();
    } else {
        const errorMessage = isAddingApplicant()
            ? 'Du har ikke valgt hvilken kontaktperson du vil tilføje'
            : 'Du har ikke valgt hvilke kontaktpersoner du vil tilføje';
        fdsShowError($modal, errorMessage);
    }
}

function handleContacts(json, $modal, caseType) {
    const contactTable = $('#addressBookContacts');

    if (json.contacts.length === 0) {
        fdsShowError($modal, 'Din adressebog er tom. Du kan tilføje kontakter under menupunktet Adressebog.');
        contactTable.hide();
        $('#btnAddContact').hide();
        return;
    }

    const addingApplicant = isAddingApplicant();
    const type = addingApplicant ? 'radio' : 'checkbox';
    const controls = [];
    const rows = [];
    $.each(json.contacts, function (index, result) {
        if ((caseType === 'gnt' || caseType === 'st') && result.type === 'person') {
            return;
        }
        if (addingApplicant && !result.roles.includes('applicant')) {
            return;
        }
        const roles = result.roles.map(role => json.roleTranslation[role]);
        const label = `Vælg ${result.title.replace(/"/g, '&quot;')} med rolle ${roles.join(' og ')}`;
        controls.push(`contactResult${index}`);
        rows.push(`
            <tr>
                <td>
                    <div class="form-group-${type}">
                        <input id="contactResult${index}" name="contactResult" value="${index}" type="${type}"
                               class="form-${type}" aria-label="${label}">
                        <label class="form-label" for="contactResult${index}"></label>
                    </div>
                </td>
                <td><label for="contactResult${index}">${result.title}</label></td>
                <td><label for="contactResult${index}">${roles.join(', ')}</label></td>
            </tr>
        `);
    });
    contactTable.find('tbody').html(rows.join(''));
    const $selectAll = $('#select-all-contacts');
    if (type === 'checkbox') {
        $selectAll
            .attr('aria-controls', controls.join(' '))
            .parent()
            .show()
            .closest('.table--responsive-scroll')
            .next('.table-actions')
            .show();
        new DKFDS.TableSelectableRows(contactTable.get(0)).init();
    } else {
        $selectAll
            .parent()
            .hide()
            .closest('.table--responsive-scroll')
            .next('.table-actions')
            .hide();
    }
    contactTable.show();
}

function doOpen($modal, theSource = '') {
    source = theSource;
    new DKFDS.Modal($modal.get(0)).show();
    const $loadingContacts = $('#loadingContacts');
    $loadingContacts.show();
    const caseType = $('#caseType').val();
    $.ajax({
        type: 'GET',
        url: '/ajax-address-book?t=' + caseType,
        async: true,
        success: function (json) {
            $loadingContacts.hide();
            if (json && json.error) {
                contacts = null;
                fdsShowError($modal, json.error);
            } else {
                contacts = json.contacts;
                handleContacts(json, $modal, caseType);
            }
        },
        error: function (e) {
            $loadingContacts.hide();
            fdsShowError($modal, 'Der opstod en fejl under indlæsning af adressebogen');
            console.error(e);
        }
    });
}

$(() => {
    const $modal = $('#addressBookModal');

    $modal.get(0).addEventListener('fds.modal.hidden', () => fdsReset($modal));

    $('#btnAddContact').on('click', () => addContacts($modal));
    $('#openAddressBookButtonApplicant').on('click', () => doOpen($modal, 'applicant'));
    $('#openAddressBookButton, #openAddressBookButtonContact').on('click', () => doOpen($modal));
});
